import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'

/**
 * Route guard — renders children only when the signed-in user holds the given
 * permission (or, given a list, any one of them); otherwise redirects to the dashboard.
 * Closes the direct-URL hole where any authenticated user could open an admin page by
 * typing its path.
 */
export default function RequirePermission({ permission, children }: { permission: string | string[]; children: React.ReactNode }) {
    const user = useAuthStore(s => s.user)
    const keys = Array.isArray(permission) ? permission : [permission]
    const allowed = keys.some(k => user?.permissions?.includes(k) ?? false)
    if (!allowed) return <Navigate to="/dashboard" replace />
    return <>{children}</>
}
